import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { AssignmentTimeslotService } from '@macs-frontend/features/company-management/agenda/service/assignment-timeslot-service';
import { BehaviorSubject } from 'rxjs';
import { ProjectTaskAssignmentTimeslot } from '@macs-gql';
import { toAppDateTime } from '@macs-frontend/core/utils/datetime';
import { calcNumSeconds, secondsToTime } from '@macs-frontend/features/shared/utils/time';
import { TimeslotConfirmationDialogService } from '@macs-frontend/features/company-management/agenda/service/timeslot-confirmation-dialog.service';

@Component({
  selector: 'md-assignments-menu-item',
  templateUrl: './assignments-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./assignments-menu-item.component.scss'],
})
export class AssignmentsMenuItemComponent implements OnInit {
  @Output() countChange = new EventEmitter<number>();

  unconfirmedCount = 0;

  timeslots$ = new BehaviorSubject<ProjectTaskAssignmentTimeslot[]>([]);

  constructor(
    private readonly timeslotService: AssignmentTimeslotService,
    private readonly cdr: ChangeDetectorRef,
    private readonly timeslotConfirmationService: TimeslotConfirmationDialogService,
  ) {}

  ngOnInit(): void {
    this.loadTimeslots();
  }

  private loadTimeslots() {
    this.timeslotService.getUnconfirmedAssignmentTimeslots().subscribe(response => {
      this.timeslots$.next(response.data);
      this.updateCount(response.data.length);
    });
  }

  private updateCount(count: number) {
    const old = this.unconfirmedCount;
    this.unconfirmedCount = count;
    this.countChange.emit(count - old);
  }

  public showConfirmDialog(timeslot: ProjectTaskAssignmentTimeslot) {
    const startTime = calcNumSeconds(timeslot.startTime ?? '00:00');
    const endTimeSeconds = startTime + (timeslot.duration || 0);
    const date = toAppDateTime(new Date(timeslot?.date || 0));

    this.timeslotConfirmationService
      .openFormDialog({
        uuid: timeslot.uuid,
        date,
        startTime: timeslot.startTime ?? '00:00',
        endTime: secondsToTime(endTimeSeconds),
      })
      .subscribe(_ => this.loadTimeslots());
  }
}
